module.exports = __webpack_public_path__ + "components/flag/static/square/za-2266e54e66db121da17b692f12f16ed9.svg";